/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	View,
	StyleSheet
} from "react-native";

import OutputValue from "./OutputValue";
import InputLabel from "../Inputs/Layout/InputLabel";
import { SHORT_DATE_FORMAT } from "../utils/date-utils";
import Style from "@aetonix/styles";
import { useResources } from "@aetonix/hooks";

const styles = StyleSheet.create({
	label: {
		flex: 0.4,
		flexBasis: 0.4
	},
	row: {
		backgroundColor: Style.colors.itemLightGray,
		flex: 1,
		flexDirection: "row",
		padding: Style.layout.paddingSmall
	},
	value: {
		flex: 0.6,
		flexBasis: 0.6,
		paddingHorizontal: Style.layout.paddingSmall
	}
});

export default function OutputRow(props) {
	const { formatDate } = useResources();
	const schema = props.schema;
	const contrast = props.contrast;
	const containerStyle = [styles.row];

	let data = props.data;
	if (schema.inputType === "date" && data) {
		data = formatDate(data, SHORT_DATE_FORMAT, "date");
	}

	if(contrast)
		containerStyle.push({
			backgroundColor: Style.colors.black
		});

	if(schema.order % 2){
		if(contrast)
			containerStyle.push({
				backgroundColor: Style.colors.semiDarkGrey
			});
		else
			containerStyle.push({
				backgroundColor: Style.colors.itemGray
			});
	}

	return (
		<View style={containerStyle}>
			<View style={styles.label}>
				<InputLabel schema={schema} contrast={contrast} />
			</View>
			<View style={styles.value}>
				<OutputValue schema={schema} data={data} contrast={contrast} />
			</View>
		</View>
	);
}